import USER_ROLES from '../components/common/userroles';

export const STOCKER_USER_FLAG = 'isStockerUser';

const isPermissionAllowed = (item) =>
  item && (item.is_allowed === 1 || item.is_allowed === true);

const getPermissions = () => {
  try {
    return JSON.parse(sessionStorage.getItem('permissions') || '[]') || [];
  } catch (e) {
    return [];
  }
};

const getPrimaryRoleId = (roles) => {
  if (Array.isArray(roles) && roles[0] && roles[0].id) {
    return roles[0].id;
  }
  try {
    return JSON.parse(sessionStorage.getItem('permissionUser'));
  } catch (e) {
    return null;
  }
};

/** TEMP: flag Stocker so the left nav can follow Role Permissions checkboxes. */
export const syncStockerUserFlag = (roles) => {
  const isStocker = getPrimaryRoleId(roles) === USER_ROLES.STOCKER;
  localStorage.setItem(STOCKER_USER_FLAG, isStocker ? 'true' : 'false');
  return isStocker;
};

export const isStockerNavGated = () => {
  try {
    const permissionUser = JSON.parse(sessionStorage.getItem('permissionUser'));
    if (permissionUser === USER_ROLES.STOCKER) {
      localStorage.setItem(STOCKER_USER_FLAG, 'true');
      return true;
    }
  } catch (e) {
    // fall through to stored flag
  }
  return localStorage.getItem(STOCKER_USER_FLAG) === 'true';
};

export const hasAllowedPermission = ({ entityType, name } = {}) => {
  return getPermissions().some((item) => {
    if (!isPermissionAllowed(item)) {
      return false;
    }
    if (entityType && String(item.permission_entity_type || '').trim() !== entityType) {
      return false;
    }
    if (name && String(item.name || '').trim() !== name) {
      return false;
    }
    return true;
  });
};

/** When the Stocker flag is on, require a matching allowed permission. Otherwise keep current behavior. */
export const canShowNavItem = (entityType, name) => {
  if (!isStockerNavGated()) {
    return true;
  }
  return hasAllowedPermission({ entityType, name });
};

export const clearStockerUserFlag = () => {
  localStorage.setItem(STOCKER_USER_FLAG, 'false');
};



// WEBPACK FOOTER //
// ./src/utils/stockerNavPermissions.js